module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetHigh.fb2cacc.webp";